import { Component, Input } from '@angular/core';

import { Router, RouterModule } from '@angular/router';
import { FileService } from '../../services/file.service';
import { FileDto } from '../../interfaces/cpe-interfaces.index';

@Component({
  selector: 'app-link',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './link.component.html',
  styleUrl: './link.component.scss',
})
export class LinkComponent {
  @Input({ required: true }) text!: string;
  @Input() ariaLabel = '';
  @Input() icon?: string;
  @Input() fullWidth?: boolean;
  @Input() link!: string;
  @Input() variantLink: 'link' | 'download' | 'button' = 'link';
  @Input()
  weight: 'light' | 'regular' | 'medium' | 'bold' | 'italic' = 'regular';
  @Input()
  variant:
    | 'd1'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'body-10'
    | 'body-20'
    | 'body-30'
    | 'label'
    | 'input'
    | 'button-10'
    | 'button-20'
    | 'b1'
    | 'h1-d1'
    | 'h2-fce'
    | 'li-body-20'
    | 'assistive' = 'body-20';
  @Input() externalLink = false;
  @Input() file?: FileDto;

  constructor(private readonly router: Router, private readonly fileService: FileService) { }

  onKeyUpLink(event: KeyboardEvent) {
    const pressedKey = event.key;

    if (pressedKey === ' ') {
      this.router.navigate([this.link]);
    }
  }
  onKeyUpDownload(event: KeyboardEvent) {
    const pressedKey = event.key;

    if (pressedKey === ' ') {
      this.downloadFile();
    }
  }

  downloadClickEvent(event: MouseEvent) {
    event.preventDefault();
    this.downloadFile();
  }

  downloadFile() {
    if (this.file) {
      this.fileService.downloadPdf(this.file.url).subscribe((blob) => {
        const link = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        link.href = objectUrl;
        link.download = this.file?.name ?? 'archivo.pdf';

        link.click();
        URL.revokeObjectURL(objectUrl); // clean memory
      });
    }
  }
}
